import { HeadingGroup, NavGroup } from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import { Link } from "react-router-dom";
import Style from "../../Billings/staffBilling.module.scss";
import useInvoices from "./useInvoices";
import Pending from "./Pending";
import Completed from "./Completed";

const Invoices = () => {
  const { tabNavs, isPending } = useInvoices();

  return (
    <div>
      <HeadingGroup title={"Cash Receipt"} className={`pro-mb-4`} />
      <div className="col-auto pro-pt-3 pro-pb-6">
        <div className={`${Style.main_container}`}>
          <NavGroup navigations={tabNavs} type={"type-2"} Link={Link} />
        </div>
        {isPending ? <Pending /> : <Completed />}
      </div>
    </div>
  );
};

export default Invoices;
